// extracted by mini-css-extract-plugin
module.exports = {"container":"OutputTabs_container__1iSo9","tabs-container":"OutputTabs_tabs-container__l12ig","tab":"OutputTabs_tab__Tv27u"};